/**
 * Builds the query-param record for the paginated CustomObjectsManagement
 * endpoints, omitting unset values. All values are stringified for the URL.
 */
export interface CustomObjectsQueryParams {
  co_type_id?: number;
  status?: string;
  anchor?: string;
  search_term?: string;
  limit?: number;
  offset?: number;
}

export const buildCustomObjectsQueryParams = (params: CustomObjectsQueryParams): Record<string, string> => {
  const queryParams: Record<string, string> = {};
  if (params.co_type_id != null) {
    queryParams.co_type_id = String(params.co_type_id);
  }
  if (params.status != null && params.status !== "") {
    queryParams.status = params.status;
  }
  if (params.anchor != null && params.anchor !== "") {
    queryParams.anchor = params.anchor;
  }
  if (params.search_term != null && params.search_term !== "") {
    queryParams.search_term = params.search_term;
  }
  if (params.limit != null) {
    queryParams.limit = String(params.limit);
  }
  if (params.offset != null) {
    queryParams.offset = String(params.offset);
  }
  return queryParams;
};
